import { defineChannelContract } from 'shared/channels';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { ProjectModel } from 'shared/domain/project/types/model';

/**
 * The project the user works in. Selecting one blocks the worker's requests
 * while the previous project's data is cleared; the answer comes once they
 * run again. Every switch is broadcast (other tabs, the worker's IndexedDB
 * subscriptions); `project` is missing when the selection was cleared.
 */
export const selectedProjectContract = defineChannelContract<{
  requests: {
    select: { request: { projectId: string }; response: ProjectModel };
    /** `null` when no project is selected (or it is no longer the user's). */
    getSelected: { request: undefined; response: ProjectModel | null };
  };
  events: {
    [DomainMessagesTypes.selectedProject]: { project?: ProjectModel };
  };
}>('selectedProjectChannel');
